'use client'

import { DefaultTypedEditorState } from '@payloadcms/richtext-lexical'

import { BlockLink } from '@/components/BlockLink'
import { TabContentProps } from '@/components/HomeTabContent'
import { Media } from '@/components/Media'
import { RevealSection } from '@/components/RevealSection'
import RichText from '@/components/RichText'
import { RenderLink } from '@/heros/HeroCenter'

import ImpactIcon from './ImpactIcon'

type AboutProps = {} & TabContentProps

const isInternalLink = (href: string): boolean => {
  const hostName = typeof window !== 'undefined' ? window.location.hostname : ''

  if (href.startsWith('/') || href.includes(hostName)) {
    return true
  }

  return false
}

const About: React.FC<AboutProps> = ({ title, image, content, link, join, impactRow }) => {
  return (
    <div className="py-6 md:py-12">
      <RevealSection
        stagger
        className="flex w-full flex-col items-stretch justify-between gap-10 md:grid md:grid-cols-2 lg:grid-cols-[minmax(0,2fr)_minmax(0,3fr)] xl:gap-20"
      >
        <Media
          resource={image}
          className="relative w-full self-start"
          imgClassName="aspect-3/2 rounded-xl object-cover md:aspect-7/9"
        />
        <div className="w-full">
          <h2 className="text-xl font-semibold text-foreground">{title}</h2>
          <RichText
            data={content as unknown as DefaultTypedEditorState}
            className="m-0 w-full px-0 py-3 text-card-foreground"
          />
          <RenderLink link={link} color="evergreen" icon={false} className="font-medium" />
          {join && (
            <div className="my-8 flex w-full flex-col gap-5 md:grid md:grid-cols-2 xl:my-14 xl:gap-10">
              {join.map((joinItem) => (
                <BlockLink
                  key={joinItem.id}
                  href={joinItem.join.link.url ?? ''}
                  title={joinItem.join.link.label ?? ''}
                  subtitle={joinItem.join.content ?? ''}
                  isInternalLink={isInternalLink(joinItem.join.link.url ?? '')}
                  newTab={joinItem.join.link.newTab ?? false}
                />
              ))}
            </div>
          )}
          {impactRow && (
            <div className="grid gap-3 xxs:grid-cols-2 md:gap-5">
              {impactRow.map((impactItem) => (
                <ImpactIcon
                  key={impactItem.id}
                  icon={impactItem.impact?.icon ?? ''}
                  content={impactItem.impact?.content ?? ''}
                />
              ))}
            </div>
          )}
        </div>
      </RevealSection>
    </div>
  )
}

export default About
